export { default } from './SectionHeader';
export type { SectionHeaderProps } from './SectionHeader';
